<template>
  <div
    v-show="crossSellingItems.length"
    class="cross-selling-wrapper mt-2 component-loading with-icon"
    :class="{ 'isLoading': isBasketLoading }"
  >
    <hr>
    <p class="title">
      {{ $translate("PerformanceWheels::Template.crossSellingAccessoryTitle") }}<!--
          --><span class="ml-2">{{ $translate("PerformanceWheels::Template.crossSellingAccessoryTitleDescription") }}</span>
    </p>

    <div class="cross-selling-row ">
      <div class="row no-gutters">
        <div
          v-for="crossItm in crossSellingItems"
          :key="crossItm.variation.id"
          class="col-12 col-sm-6 col-lg-12_ p-1"
        >
          <popper v-cloak placement="left" class="popper d-inline-flex align-self-center pr-2">
            <template #handle>
              <button class="btn btn-icon btn-secondary btn-sm p-2">
                <i class="fa fa-info"></i>
              </button>
            </template>
            <template #content>
              {{ crossItm.texts.shortDescription }}
            </template>
          </popper>

          <article
            class="cmp cmp-product-thumb h-100_X mb-0 p-0 accessory-item cross-item"
            :data-item-id="crossItm.item.id"
            :data-price="crossItm.prices.default.unitPrice.value"
            :data-variation-id="crossItm.variation.id"
            :class="{ 'cross-item-active' : selectedCrossItems.some(si => si.variationId === crossItm.variation.id) }"
            @click.prevent="toggleCrossSellingItem(crossItm.variation.id)"
          >
            <div
              v-if="hasItemTooltip(crossItm)"
              v-tooltip
              class="cross-tooltip"
              data-toggle="tooltip"
              data-placement="top"
              :title="crossItm.texts.shortDescription"
            />

            <div class="thumb-inner d-flex flex-sm-column_X h-100">
              <div class="thumb-image col-3 col-sm-4">
                <img
                  v-if="hasItemImage(crossItm)"
                  :src="crossItm.images.all[0].urlMiddle"
                  :alt="crossItm.texts.name1"
                >
              </div>

              <div class="thumb-content d-flex flex-column col-9 col-sm-8">
                <div class="name">
                  {{ crossItm.texts.name1 }}
                  <span class="unitNumber">{{ crossItm.texts.name2 }}</span>
                </div>
                <div class="prices d-flex align-items-end">
                  <div class="price text-color-primary ml-auto">
                    + {{ crossItm.prices.default.unitPrice.formatted }}
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// Um webpack auszuführen muss 'npm install' in Ceres und PerformanceWheels ausgeführt werden
import ApiService from '../../../../../../../Ceres/resources/js/src/app/services/ApiService'
import ExceptionMap from '../../../../../../../Ceres/resources/js/src/app/exceptions/ExceptionMap'

export default {
  name: 'BasketCrossSelling',
  data () {
    return {
      crossSellingItems: []
    }
  },

  computed:
        {
          notificationService () {
            return window.NotificationService
          },
          crossItemIds () {
            return this.crossSellingItems.map(itm => itm.variation.id)
          },
          selectedCrossItems () {
            return this.basketItems.filter(itm => this.crossItemIds.includes(itm.variationId))
          },
          ...mapState({
            basketItems: state => state.basket.items,
            isBasketLoading: state => state.basket.isBasketLoading
          })
        },

  watch:
          {
            basketItems (val) {
              // IDEA: für zukünftige optimierung: crossItems pro basketitem
              // speichern und nach jedem durchgang prüfen ohne neuen API request auszulösen
              /* always reload -> zeigt immer die korrekten CS items, stört aber!
                this.crossSellingItems = [];
                this.loadCrossItems(); */
              /* simplified solution */
              //              if (!this.crossSellingItems.length) this.loadCrossItems()
              this.loadCrossItems()
              if (!val.length) this.crossSellingItems = []
            }
          },
  //  mounted () {
  //    this.$nextTick(() => {
  //      this.loadCrossItems()
  //      if (!this.basketItems.length) this.crossSellingItems = []
  //    })
  //  },

  methods:
        {
          loadCrossItems () {
            this.basketItems.forEach(bItm => {
              ApiService.get(window.location.origin + '/rest/performancewheels/crosssellingitems', { id: bItm.itemId })
                .done(res => { if (res.length) this.addUniques(res) })
                .catch(error => console.log(error))
            })
          },
          addUniques (items) {
            items.forEach(itm => {
              if (!this.crossItemIds.includes(itm.variation.id)) {
                this.crossSellingItems.push(itm)
              }
            })
          },
          hasItemTooltip (crossItem) {
            return !!crossItem.texts.shortDescription
          },
          hasItemImage (crossItem) {
            return crossItem.images && crossItem.images.all[0] && crossItem.images.all[0].urlMiddle
          },
          addToBasekt (varId) {
            const basketObj = {
              basketItemOrderParams: [],
              quantity: 1,
              template: 'Ceres::Basket.Basket',
              templateEvent: 'tpl.item',
              variationId: varId
            }

            return this.$store.dispatch('addBasketItem', basketObj)
          },
          toggleCrossSellingItem (crossId) {
            const csBasketItem = this.selectedCrossItems.find(item => item.variationId === crossId)
            //            if (csBasketItem) {
            //              this.$store.dispatch('removeBasketItem', csBasketItem.id).catch(error => {
            //                console.log(error)
            //                this.isLoading = false
            //
            //                if (error.data) {
            //                  this.notificationService.error(
            //                    this.$translate(this.getExceptionString(error), error.data.placeholder)
            //                  ).closeAfter(5000)
            //                }
            //              })
            //            } else {
            if (!csBasketItem) {
              this.addToBasekt(crossId).catch(error => {
                console.log(error)
                this.isLoading = false

                if (error.data) {
                  this.notificationService.error(
                    this.$translate(this.getExceptionString(error), error.data.placeholder)
                  ).closeAfter(5000)
                }
              })
            }
            // hide all tooltips while loading
            $('.cross-item').tooltip('hide')
          },
          getExceptionString (error) {
            const exceptionName = ExceptionMap.get(error.data.exceptionCode.toString())
            if (exceptionName) return 'Ceres::Template.' + exceptionName

            return 'PerformanceWheels::Template.errorBasketItemDefault'
          }
        }

}
</script>
